import React from 'react';
import { Link } from 'react-router';
import { IFooterColumn, IFooterLink, IProps } from './types';
import styles from './footer.module.scss';

const FooterLink = (props: IFooterLink): React.ReactElement => {
  const content = (
    <>
      {props.icon}
      {props.text}
    </>
  );

  if (props.link.startsWith('http')) {
    return (
      <a
        href={ props.link }
        target='_blank'
        rel='noopener noreferrer'>
        {content}
      </a>
    );
  }

  return (
    <Link to={ props.link }>{content}</Link>
  );
};

export const Footer = (props: IProps): React.ReactElement => {
  return (
    <footer className={ styles.footer }>
      <div className={ styles.columns }>
        {props.columns.map((column: IFooterColumn) => (
          <nav
            key={ column.title }
            aria-label={ column.title }
            className={ styles.column }>
            <p className={ styles.columnTitle }>{column.title}</p>

            <ul>
              {column.links.map((link: IFooterLink) => (
                <li key={ link.link }>
                  <FooterLink { ...link } />
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <p className={ styles.bottom }>{props.bottomText}</p>
    </footer>
  );
};
